var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "framerate-marker-inspector" },
    [
      !_vm.marker
        ? _c("div", { staticClass: "vue-ui-empty" }, [
            _vm._v("\n    No marker selected\n  ")
          ])
        : _c(
            "SplitPane",
            [
              _c(
                "div",
                {
                  staticClass: "entries",
                  attrs: { slot: "left" },
                  slot: "left"
                },
                _vm._l(_vm.marker.bubbles, function(bubble) {
                  return _c(
                    "div",
                    {
                      key: bubble.type,
                      staticClass: "group",
                      class: {
                        "high-density": _vm.finalHighDensity
                      }
                    },
                    [
                      _c("div", { staticClass: "group-title" }, [
                        _vm._v(
                          "\n          " + _vm._s(bubble.type) + "\n        "
                        )
                      ]),
                      _vm._l(bubble.entries, function(entry, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "entry list-item",
                            class: {
                              selected: _vm.selectedEntry === entry
                            },
                            on: {
                              click: function($event) {
                                _vm.selectedEntry = entry
                              }
                            }
                          },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(entry.label) +
                                  "\n          "
                              )
                            ]),
                            _c("div", { staticClass: "time" }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm._f("formatTime")(
                                      entry.timestamp,
                                      _vm.$shared.timeFormat
                                    )
                                  ) +
                                  "\n          "
                              )
                            ])
                          ]
                        )
                      })
                    ],
                    2
                  )
                }),
                0
              ),
              _vm.selectedEntry
                ? _c("StateInspector", {
                    staticClass: "state-inspector",
                    attrs: { slot: "right", state: _vm.selectedEntry.state },
                    slot: "right"
                  })
                : _vm._e()
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }